export const SAVE_ALL_SERVICES = 'SAVE_ALL_SERVICES'